"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _applicationInsights = require("./application-insights");
Object.keys(_applicationInsights).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _applicationInsights[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _applicationInsights[key];
        }
    });
});
var _constants = require("./constants");
Object.keys(_constants).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _constants[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _constants[key];
        }
    });
});
var _formatError = require("./internal/formatError");
Object.keys(_formatError).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _formatError[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _formatError[key];
        }
    });
});
var _Logger = require("./Logger");
Object.keys(_Logger).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _Logger[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _Logger[key];
        }
    });
});
var _measureFunctionDuration = require("./measureFunctionDuration");
Object.keys(_measureFunctionDuration).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _measureFunctionDuration[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _measureFunctionDuration[key];
        }
    });
});
var _loggerConfigurationSchema = require("./loggerConfigurationSchema");
Object.keys(_loggerConfigurationSchema).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _loggerConfigurationSchema[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _loggerConfigurationSchema[key];
        }
    });
});
var _react = require("./react");
Object.keys(_react).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _react[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _react[key];
        }
    });
});
var _types = require("./types");
Object.keys(_types).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _types[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _types[key];
        }
    });
}); //# sourceMappingURL=index.js.map
